import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { Marketday } from '../../../../../entities';

@Component({
  selector: 'app-administration-io',
  templateUrl: './administration-io.component.html',
  styles: []
})
export class AdministrationIoComponent implements OnInit {

  loadingIndicator: boolean;

  importMarketdateboothOutput: string;
  importMarketdateboothByMarketdayOutput: string;
  marketdayId: string = null;
  marketdays: Array<Marketday>;
  exportMessageImagesOutput: string;
  exportMarketdateCommentsOutput: string;
  exportMarketdateExpensesOutput: string;

  constructor(private apiService: ApiService) {
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.getMarketdays()
      .then(() => this.loadingIndicator = false)
      .catch(() => this.loadingIndicator = false);
  }

  getMarketdays(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.find<Marketday>(Marketday, 'marketdays/', {params: {size: 500}})
        .subscribe((marketdays: Array<Marketday>) => {
          this.marketdays = marketdays.sort((a, b) => {
            const keywordA = a.keyword;
            const kaywordB = b.keyword;
            if (keywordA < kaywordB) {
              return -1;
            }
            if (keywordA > kaywordB) {
              return 1;
            }
            return 0;
          });
          resolve();
        }, e => {
          console.log('error loading marketdays', e);
          reject();
        });
    });
  }

  importMarketdateBooth() {
    this.importMarketdateboothOutput = 'loading';
    this.apiService.get('marketdate-booth-import/').subscribe(res => {
      this.importMarketdateboothOutput = res;
    }, err => {
      this.importMarketdateboothOutput = err;
    });
  }

  importMarketdateBoothByMarketday() {
    if (this.marketdayId) {
      this.importMarketdateboothByMarketdayOutput = 'loading';
      console.log('import marketdayBooths by marketday with id:', this.marketdayId);
      console.log('marketday: ', this.marketdays.find(m => m.id === parseInt(this.marketdayId, 10)));
      this.apiService.get('marketdate-booth-import-by-marketday/' + this.marketdayId)
        .subscribe(res => {
          this.importMarketdateboothByMarketdayOutput = res;
        }, e => {
          this.importMarketdateboothByMarketdayOutput = 'Oh oh! - Error: ' + e;
        });
    } else {
      this.importMarketdateboothByMarketdayOutput = 'Please select marketday!';
    }
  }

  exportMessageImages() {
    this.exportMessageImagesOutput = 'loading';
    this.apiService.get('messages/export-images/').subscribe(res => {
      this.exportMessageImagesOutput = res;
    }, err => {
      this.exportMessageImagesOutput = err;
    });
  }

  exportMarketdateComments() {
    this.exportMarketdateCommentsOutput = 'loading';
    this.apiService.get('marketdate-comments/export-images/').subscribe(res => {
      this.exportMarketdateCommentsOutput = res;
    }, err => {
      this.exportMarketdateCommentsOutput = err;
    });
  }

  exportMarketdateExpenses() {
    this.exportMarketdateExpensesOutput = 'loading';
    this.apiService.get('marketdate-expenses/export-images/').subscribe(res => {
      this.exportMarketdateExpensesOutput = res;
    }, err => {
      this.exportMarketdateExpensesOutput = err;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/components/administration/components/administration-io/administration-io.component.ts